import { ItemTab } from "@saleor/changeOrderDomestic/views/ViewEditOrder/types";
import { makeStyles } from "@saleor/macaw-ui";
import Palette from "@saleor/themes/palette";

const useStyles = makeStyles(
  theme => ({
    root: {
      marginTop: "4rem"
    },
    tabB: {
      marginLeft: "-3rem"
    },
    active: {
      backgroundColor: theme.palette.info.main,
      "& .MuiTypography-root": {
        color: "#FFFFFF"
      }
    },
    notActive: {
      backgroundColor: theme.palette.grey[300],
      "& .MuiTypography-root": {
        color: theme.palette.grey[600]
      }
    },
    z0: {
      zIndex: 0
    },
    z1: {
      zIndex: 1
    },
    z2: {
      zIndex: 2
    },
    z3: {
      zIndex: 3
    },
    z4: {
      zIndex: 4
    },
    tabBox: {
      display: "flex"
    },
    boxTable: {
      border: `solid 1px #007E92`,
      overflowX: "auto",
      "&::-webkit-scrollbar": {
        height: "14px",
        background: "#FFFFFF"
      },
      "&::-webkit-scrollbar-track": {
        borderRadius: 10
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#CCCCCC",
        borderRadius: 10,
        border: "4px solid #FFFFFF",
        height: "6px"
      },
      "& .MuiTable-root": {
        "& .MuiTableCell-body": {
          "& .MuiFormControl-root": {
            height: 38.4
          }
        }
      },
      "& .MuiTableCell-root": {
        padding: "8px",
        height: (props: any) =>
          props.activeTab === ItemTab.tabC ? 80 : "48px",
        border: `.5px solid ${theme.palette.grey[300]}`
      },
      "& .MuiCheckbox-root": {
        margin: 0,
        "&.colCheck": {
          margin: "0px 5px 0px 2px"
        },
        "& input": {
          width: 40,
          height: 40,
          top: "-10px",
          left: "-10px"
        }
      },
      "& .MuiTableCell-head": {
        height: 48
      }
    },
    topBox: {
      position: "relative",
      display: "flex",
      justifyContent: "flex-end",
      marginBottom: "-3rem",
      height: "3.2rem"
    },
    normalText: {
      fontWeight: "normal"
    },
    noBorder: {
      border: "0 !important"
    },
    noBorderLeft: {
      borderLeft: "0 !important"
    },
    noBorderRight: {
      borderRight: "0 !important"
    },
    cellFrezze0: {
      position: "sticky",
      width: 40,
      left: 0,
      background: "inherit",
      zIndex: 1,
      paddingLeft: "9px !important",
      paddingRight: "9.4px !important"
    },
    cellFrezze1: {
      minWidth: 64,
      position: "sticky",
      left: 40,
      background: "inherit",
      zIndex: 1,
      "& svg": {
        width: 25
      },
      "&>div>div": {
        marginRight: "-1rem"
      }
    },
    cellFrezze1Add: {
      minWidth: 64,
      position: "sticky",
      left: 0,
      background: "inherit",
      zIndex: 1,
      "& svg": {
        width: 25
      },
      "& .MuiTypography-root": {
        textAlign: "center"
      },
      padding: "0.8rem !important",
      "&>div>div": {
        marginRight: "-1rem"
      }
    },
    cellFrezze2: {
      minWidth: 174,
      maxWidth: 174,
      position: "sticky",
      left: 104,
      background: "inherit",
      zIndex: 1
    },
    cellFrezze2Add: {
      minWidth: 174,
      maxWidth: 174,
      position: "sticky",
      left: 64,
      background: "inherit",
      zIndex: 1
    },
    cellFrezze3: {
      minWidth: (props: any) => (props?.activeTab === ItemTab.tabC ? 165 : 289),
      position: "sticky",
      left: 278,
      background: "inherit",
      zIndex: 1,
      borderRight: "0 !important"
    },
    cellFrezze3Add: {
      minWidth: (props: any) => (props?.activeTab === ItemTab.tabC ? 187 : 311),
      position: "sticky",
      left: 238,
      background: "inherit",
      zIndex: 1,
      borderRight: "0 !important"
    },
    cellFrezze4: {
      position: "sticky",
      left: (props: any) => (props?.activeTab === ItemTab.tabC ? 431 : 567),
      minWidth: 59,
      background: "inherit",
      zIndex: 1,
      borderLeft: "0 !important",
      "& svg": {
        cursor: "pointer"
      }
    },
    titleDelete: {
      color: theme.palette.error.light
    },
    requiredMark: {
      color: theme.palette.error.main,
      fontWeight: 400
    },
    cellFrezze4Add: {
      position: "sticky",
      left: (props: any) => (props?.activeTab === ItemTab.tabC ? 425 : 549),
      minWidth: 37,
      background: "inherit",
      zIndex: 1,
      borderLeft: "0 !important",
      "& svg": {
        cursor: "pointer"
      }
    },
    btnExternal: {
      height: 32,
      margin: "-3px -0.8px",
      minWidth: 32,
      width: 36,
      padding: 6
    },
    colA0: {
      minWidth: 120
    },
    colA1: {
      minWidth: 200,
      "@media (min-width: 90%)": {
        minWidth: 300
      }
    },
    colA2: {
      minWidth: 140
    },
    colA2Add: {
      minWidth: 140
    },
    colA3: {
      minWidth: 112
    },
    colA4: {
      minWidth: 120,
      "& .MuiFormControl-root": {
        width: 120
      }
    },
    colA4Add: {
      minWidth: 120,
      "& .MuiFormControl-root": {
        width: 120
      }
    },
    colA5: {
      minWidth: 64
    },
    col5Add: {
      minWidth: 64
    },
    colA6: {
      minWidth: 64,
      textWrap: "nowrap"
    },
    colA7: {
      minWidth: 104
    },
    colA8: {
      minWidth: 112
    },
    colA9: {
      minWidth: 96
    },
    colA10: {
      minWidth: 120
    },
    colA11: {
      minWidth: 80
    },
    colA12: {
      minWidth: 136,
      textWrap: "nowrap",
      padding: "8px 7px !important"
    },
    colA13: {
      minWidth: 80
    },
    colA14: {
      minWidth: 172
    },
    colA15: {
      minWidth: 434
    },
    colA16: {
      minWidth: 112
    },
    colA17: {
      minWidth: 136
    },
    colA18: {
      minWidth: 120
    },
    colA18IS: {
      minWidth: 144
    },
    colA19: {
      boxSizing: "content-box",
      textWrap: "nowrap",
      padding: "0px 4px 0px 11px !important",
      minWidth: 56
    },
    colA20: {
      boxSizing: "content-box",
      textWrap: "nowrap",
      padding: "0px 8px 0px 5px !important",
      minWidth: 56
    },
    colA21: {
      boxSizing: "content-box",
      textWrap: "nowrap",
      padding: "0px 7px 0px 6px !important",
      minWidth: 80
    },

    colA22: {
      minWidth: 80
    },
    colA23: {
      minWidth: 64
    },
    colA24: {
      minWidth: 56
    },
    colA25: {
      minWidth: 88
    },
    colA26: {
      minWidth: 72
    },
    cellNumberInput: {
      "& .MuiFormControl-root": {
        width: 120
      }
    },
    cellFlexCenter: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    cellSize13: {
      fontSize: "1.3rem"
    },
    cellUnlimited: {
      background: "#F2FAFB !important"
    },
    checkBoxDisabled: {
      background: theme.palette.grey[200]
    },
    colB1: {
      minWidth: 138
    },
    colB2: {
      minWidth: 138
    },
    colB3: {
      minWidth: 138
    },
    colB4: {
      minWidth: 138
    },
    colB5: {
      minWidth: 138
    },
    colB6: {
      minWidth: 80
    },
    colB7: {
      minWidth: 64
    },
    colB8: {
      minWidth: 56
    },
    cellBtn: {
      "& button": {
        fill: "currentColor",
        "& svg": {
          fill: "inherit",
          "& path": {
            fill: "inherit"
          }
        }
      }
    },
    colC1: {
      minWidth: 312
    },
    colC2: {
      minWidth: 248
    },
    colC3: {
      minWidth: 248
    },
    colC4: {
      minWidth: 248
    },
    colC5: {
      minWidth: 248
    },
    boxBackground: {
      borderRadius: 4,
      background: theme.palette.background.default,
      padding: "6px 16px",
      minHeight: 58
    },
    txtInputSelect: {
      "&>div": {
        fontWeight: 400
      }
    },
    selectField: {
      "& .MuiSelect-root": {
        padding: "0.4rem 1.2rem"
      }
    },
    rowFlex: {
      display: "flex",
      alignItems: "center",
      gap: 10
    },
    rowFlexSpace: {
      minHeight: 54,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      gap: 10
    },
    additionaltxtarea: {
      "& textarea": {
        height: "43px !important"
      }
    },
    inputUnlimit: {
      width: 56,
      "& input": {
        padding: "6px 9px"
      }
    },
    btnThin: {
      height: 32
    },
    btnApplyAllAdd: {
      borderRadius: "4px",
      padding: "0.4rem 0.8rem",
      fontWeight: 400,
      fontSize: "1.2rem",
      lineHeight: "18px",
      background: "#009FB8",
      color: "white",
      boxShadow:
        "rgba(0, 0, 0, 0.16) 0px 2px 3px, rgba(0, 0, 0, 0.23) 0px 2px 3px",
      "&:hover, &:active": {
        color: "#009FB8",
        background: "#F2FAFB",
        outline: "1px solid #009FB8",
        boxShadow:
          "rgba(0, 0, 0, 0.16) 0px 2px 3px, rgba(0, 0, 0, 0.23) 0px 2px 3px"
      }
    },
    btnApplyAll: {
      marginTop: 10,
      height: 32,
      padding: "1rem",
      background: "#FFF",
      "&:hover": {
        background: "#FFF",
        border: `solid 1px ${theme.palette.info.main}`
      },
      "&:active": {
        outline: "3px solid rgba(1, 178, 237, 0.32)"
      },
      "& .MuiTypography-root": {
        color: theme.palette.grey[900]
      }
    },
    textConfirmDate: {
      color: theme.palette.info.dark
    },
    textRequestDate: {
      marginBottom: 10
    },
    cellHeadCheck: {
      paddingLeft: "5px !important"
    },
    pointer: {
      cursor: "pointer"
    },
    disabledLine: {
      color: theme.palette.grey[500],
      "& .MuiTypography-root": {
        color: theme.palette.grey[500]
      },
      "& .MuiTypography-root > * ": {
        color: theme.palette.grey[500]
      },
      "& span": {
        color: theme.palette.grey[500]
      }
    },
    backIcon: {
      "& path": {
        fill: theme.palette.grey[500]
      }
    },
    wrongDate: {
      color: theme.palette.error.light
    },
    matchDate: {
      color: theme.palette.info.dark
    },
    pre: {
      whiteSpace: "pre-line"
    },
    boxCancel: {
      background: theme.palette.grey[200],
      borderRadius: 4,
      width: 72,
      padding: "3px 8px",
      color: theme.palette.error.dark,
      userSelect: "none"
    },
    boxDelete: {
      background: theme.palette.grey[200],
      borderRadius: 4,
      width: 51,
      padding: "3px 8px",
      color: theme.palette.grey[900],
      userSelect: "none"
    },
    searchbtn: {
      height: 30
    },
    btnIcon: {
      paddingLeft: 0,
      paddingRight: 0,
      minWidth: 30,
      minHeight: 30,
      borderRadius: 4,
      "&:hover": {
        background: "#F2FAFB"
      },
      "&:active": {
        outline: `3px solid rgba(1, 178, 237, 0.32)`
      },
      "&.Mui-disabled": {
        background: `${Palette.grey[300]} !important`,
        color: "#FFF !important",
        "& svg>path": {
          stroke: "#FFF !important"
        }
      }
    },
    innerTabActive: {
      WebkitClipPath: "polygon(0 0, 77.5% 0, 99% 100%, 0% 100%)",
      clipPath: "polygon(0 0, 77.5% 0, 99% 100%, 0% 100%)",
      width: "199px",
      height: "39px",
      boxShadow: "2px 0px 4px rgba(0, 0, 0, 0.25)",
      borderTopLeftRadius: "5px",
      display: "flex",
      alignItems: "center",
      paddingLeft: "2.4rem",
      cursor: "pointer",
      top: 1,
      left: 1,
      background: theme.palette.info.main,
      position: "absolute",
      borderBottom: 0,
      color: "#FFFFFF"
    },
    tableTab: {
      WebkitClipPath: "polygon(0 0, 78% 0, 100% 100%, 0% 100%)",
      clipPath: "polygon(0 0, 78% 0, 100% 100%, 0% 100%)",
      width: "200px",
      height: "40px",
      boxShadow: "2px 0px 4px rgba(0, 0, 0, 0.25)",
      borderTopLeftRadius: "6px",
      display: "flex",
      alignItems: "center",
      paddingLeft: "2.4rem",
      cursor: "pointer",
      position: "relative",
      justifyContent: "start",
      borderBottomLeftRadius: 0,
      borderBottom: 0
    },
    tableTabActive: {
      background: theme.palette.info.dark
    },
    tableTabInactive: {
      background: theme.palette.grey[400]
    },
    innerTab: {
      WebkitClipPath: "polygon(0 0, 77.5% 0, 99% 100%, 0% 100%)",
      clipPath: "polygon(0 0, 77.5% 0, 99% 100%, 0% 100%)",
      width: "199px",
      height: "39px",
      boxShadow: "2px 0px 4px rgba(0, 0, 0, 0.25)",
      borderTopLeftRadius: "5px",
      display: "flex",
      alignItems: "center",
      paddingLeft: "2.4rem",
      cursor: "pointer",
      top: 1,
      left: 1,
      background: theme.palette.grey[300],
      color: theme.palette.grey[600],
      position: "absolute",
      borderBottom: 0
    },
    zMax: {
      zIndex: 100
    },
    errorTextRequestDate: {
      marginTop: 5,
      color: theme.palette.error.light
    },
    errorText: {
      color: theme.palette.error.light
    },
    btnSubmit: {
      padding: "5px 28px",
      height: "32px"
    },
    cellSplit: {
      position: "sticky",
      left: 0,
      background: "inherit",
      "&.MuiTableCell-root:first-child:not(.MuiTableCell-paddingCheckbox)": {
        textAlign: "right"
      }
    },
    rowSplit: {
      background: "rgba(242, 250, 251, 1) !important",
      "&.MuiTableRow-root:hover:not(.MuiTableRow-head):not(.MuiTableRow-footer)": {
        background: "rgba(242, 250, 251, 1) !important"
      }
    },
    rowNonSplit: {
      background: "rgba(255, 255, 255, 1) !important",
      "&.MuiTableRow-root:hover:not(.MuiTableRow-head):not(.MuiTableRow-footer)": {
        background: "rgba(255, 255, 255, 1) !important"
      }
    },
    disabledItem: {
      color: theme.palette.grey[500],
      "& .MuiTypography-root": {
        color: theme.palette.grey[500]
      },
      "& .MuiTypography-root > *": {
        color: theme.palette.grey[500]
      },
      "& span": {
        color: theme.palette.grey[500]
      },
      "& .MuiTypography-root$boxCancel": {
        color: theme.palette.error.dark
      }
    }
  }),
  { name: "ItemDetailsTabEdit" }
);

export default useStyles;
